import dayjs from 'dayjs';
import { LeaveRequestDay, LeaveRequestStatus } from 'types/leave-request';

export const LEAVE_STATUS_LABEL: Record<LeaveRequestStatus, string> = {
  [LeaveRequestStatus.PENDING]: 'Chờ duyệt',
  [LeaveRequestStatus.APPROVED]: 'Đã duyệt',
  [LeaveRequestStatus.REJECTED]: 'Từ chối',
  [LeaveRequestStatus.CANCELLED]: 'Đã huỷ',
};

export const LEAVE_STATUS_COLOR: Record<LeaveRequestStatus, string> = {
  [LeaveRequestStatus.PENDING]: 'gold',
  [LeaveRequestStatus.APPROVED]: 'green',
  [LeaveRequestStatus.REJECTED]: 'red',
  [LeaveRequestStatus.CANCELLED]: 'default',
};

const DISPLAY_DATE = 'DD/MM/YYYY';

export function formatLeaveDays(days: LeaveRequestDay[] = []): string {
  const sorted = [...days].sort((a, b) => dayjs(a.date).valueOf() - dayjs(b.date).valueOf());
  if (sorted.length === 0) return '—';
  if (sorted.length === 1) return dayjs(sorted[0].date).format(DISPLAY_DATE);

  const first = dayjs(sorted[0].date);
  const isConsecutive = sorted.every((day, index) =>
    dayjs(day.date).isSame(first.add(index, 'day'), 'day')
  );

  if (isConsecutive) {
    return `${first.format(DISPLAY_DATE)} - ${dayjs(sorted[sorted.length - 1].date).format(
      DISPLAY_DATE
    )}`;
  }

  return `${first.format(DISPLAY_DATE)} + ${sorted.length - 1} ngày`;
}

export function getPersonName(person?: { nickName?: string; username?: string; email?: string }) {
  return person?.nickName || person?.username || person?.email || '—';
}
